<template>
  <div>
    <div class="owner_title">下载周稿</div>
    <!-- 筛选 -->
    <div class="btn_box">
      <div class="week_record_btn">
        <div class="book_btn" @click="downloadFileBatch()" :disable="isLock">
          <i class="iconfont icon-xiazai"></i>
          下载文件
        </div>
      </div>
      <div class="task_filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>
    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.record_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>
    <div class="task_box">
      <!-- 表格数据 -->
      <el-table
        :data="dataShow"
        @selection-change="handleSelectionChange"
        tooltip-effect="dark"
        height="550"
        border
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="connection_name"
          label="金主昵称"
          align="center"
          :width="equipmentType == 0 ? 180 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="departmentuser_name"
          label="写手编辑"
          :width="equipmentType == 0 ? 185 : 110"
          align="center"
          sortable
        >
        </el-table-column>

        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          align="center"
          :width="equipmentType == 0 ? 185 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          :width="equipmentType == 0 ? 330 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="up_title"
          label="文件名"
          align="center"
          :width="equipmentType == 0 ? 330 : 110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          :width="equipmentType == 0 ? 200 : 110"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="record_time"
          label="上传时间"
          align="center"
          :width="equipmentType == 0 ? 200 : 110"
          sortable
        >
        </el-table-column>

        <el-table-column
          label="操作"
          align="center"
          :fixed="equipmentType == 1 ? false : 'right'"
          :width="equipmentType == 0 ? 150 : 110"
        >
          <template slot-scope="scope">
            <div class="highSeas_box">
              <div @click="downloadFile(scope.row)" class="remark_btn">
                <i class="iconfont icon-xiazai"></i>
                下载附件
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { c_week_list, c_week_zip } from "@/utils/owner";
import { xz_file } from "@/utils/api";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      ownerId: "", //金主所需部门id
      fileList: [], //书籍列表
      dataShow: [], // 当前页要显示的数据,
      isFilterForm: true, //筛选按钮
      filter_form: {
        record_time: "", //上传时间
        connectionessay_name: "" //书名
      },
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      selectIds: [], //多选id列表
      isLock: false, //按钮的点击次数
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getFileList(); //任务中心列表
  },
  methods: {
    // 获取书籍下载列表
    getFileList() {
      var that = this;

      let obj = {
        departmentuser_id: that.ownerId
      };
      c_week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.fileList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 筛选
    goSearch() {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.record_time;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      that.filter_form.record_time = that.time_filter;
      let obj = {
        departmentuser_id: that.ownerId,
        ...that.filter_form
      };
      console.log("时间参数", that.filter_form);
      c_week_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.fileList = res.data.data;
          that.calcPageData();
          that.filter_form.record_time = that.select_time_data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 多选操作
    handleSelectionChange(val) {
      var that = this;
      var select_arr = [];
      val.forEach(element => {
        select_arr.push(element.id);
      });
      that.selectIds = select_arr;
    },
    // 批量下载
    downloadFileBatch() {
      var that = this;
      var select_ids = that.selectIds.join(",");
      if (that.selectIds.length == 0) {
        return false;
      }
      let obj = {
        departmentuser_id: that.ownerId,
        weekly_draft_ids: select_ids
      };
      c_week_zip(obj).then(res => {
        if (res.data.code == 1) {
          let file_name = res.data.data.title;
          let url = res.data.data.xurl;
          var suffix = file_name.substring(file_name.lastIndexOf(".")); //zip
          if (suffix == "zip") {
            var link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", file_name);
            document.body.appendChild(link);
            link.click();
            that.$message.success(res.data.msg);
          } else {
            const xhr = new XMLHttpRequest();
            xhr.open("GET", url, true); // url 文件的完整地址 http:XXX
            xhr.responseType = "blob";
            xhr.onload = function() {
              if (xhr.status === 200) {
                const res = xhr.response;
                const link = document.createElement("a");
                link.style.display = "none";
                const url = window.URL.createObjectURL(res);
                link.href = url;
                link.setAttribute("download", file_name);
                document.body.appendChild(link);
                link.click();
                console.log(link);
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              }
            };
            xhr.send();
            that.$message.success(res.data.msg);
          }
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 文件下载
    downloadFile(val) {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        weekly_draft_id: val.id
      };
      xz_file(obj).then(res => {
        if (res.data.code == 1) {
          var file_url = res.data.data.xurl;
          if (that.equipmentType == 0) {
            // pc端
            const xhr = new XMLHttpRequest();
            xhr.open("GET", file_url, true); // url 文件的完整地址 http:XXX
            xhr.responseType = "blob";
            xhr.onload = function() {
              if (xhr.status === 200) {
                const res = xhr.response;
                const link = document.createElement("a");
                link.style.display = "none";
                const url = window.URL.createObjectURL(res);
                link.href = url;
                link.setAttribute("download", file_name);
                document.body.appendChild(link);
                link.click();
                console.log(link);
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              }
            };
            xhr.send();
          } else {
            // 移动端
            let link_a = document.createElement("a");
            link_a.style.display = "none";
            link_a.href = file_url;
            document.body.appendChild(link_a);
            //  link_a.setAttribute("download", '周稿');
            link_a.click();
            URL.revokeObjectURL(link_a.href); // 释放URL 对象
            document.body.removeChild(link_a);
          }
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 关闭弹窗触发
    cancelDialog() {
      this.getFileList();
    },
    // 列表分页
    calcPageData() {
      if (this.fileList.length > 1) {
        this.pageNum = Math.ceil(this.fileList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.fileList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}

.sea_tag .el-tag.el-tag--info {
  width: 90px;
  margin: 5px auto;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.remark_btn i {
  font-size: 12px;
}
.task_box {
  margin: 0px 15px;
}
.task_filtrate {
  text-align: right;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.myowner_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  border-radius: 17px;
  margin-right: 5px;
}
.highSeas_box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sea_tag {
  text-align: center;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}
.week_record_btn {
  display: flex;
  flex-direction: row;
}
.book_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  color: #157df8;
  font-size: 14px;
  margin-right: 5px;
}
.book_btn i {
  font-size: 14px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/owner/DownLoadManuscript.vue